module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_library.js
 ** module id = 52
 ** module chunks = 2 4 5 7
 **/